import styled, { css, CSSProperties } from 'styled-components';
import { colors, Colors } from '../utils/colors';

export type Space = '4' | '8' | '12' | '16' | '24' | '32' | '40' | '64';

export type BoxProps = {
    isInline?: boolean;
    direction?: Exclude<CSSProperties['flexDirection'], '-moz-initial'>;
    gap?: Space;
    alignItems?: Exclude<CSSProperties['alignItems'], '-moz-initial'>;
    justifyContent?: Exclude<CSSProperties['justifyContent'], '-moz-initial'>;
    position?: CSSProperties['position'];
    wrap?: CSSProperties['flexWrap'];
    flex?: number;
    bg?: Colors;
    b?: { px: number; color: Colors };
    br?: Space;
    color?: Colors;
    width?: string;
    height?: string;
    y?: Space;
    x?: Space;
    brTop?: Space;
    brBottom?: Space;
    maxWidth?: string;
};

export const boxStyle = css<BoxProps>`
    display: ${(props) => (props.isInline ? 'inline-flex' : 'flex')};
    flex-wrap: ${(props) => props.wrap ?? 'wrap'};
    flex-direction: ${(props) => props.direction ?? 'row'};
    align-items: ${(props) => props.alignItems ?? 'unset'};
    justify-content: ${(props) => props.justifyContent ?? 'unset'};
    gap: ${(props) => props.gap ?? 0}px;
    flex: ${(props) => props.flex ?? 'unset'};
    border-radius: ${(props) => (props.br ? `${props.br}px` : 'unset')};
    border: ${(props) =>
        props.b ? `${props.b.px}px solid ${colors[props.b.color]} ` : 'unset'};
    background-color: ${(props) => (props.bg ? colors[props.bg] : 'unset')};
    color: ${(props) => (props.color ? colors[props.color] : 'unset')};
    width: ${(props) => (props.width ? `${props.width}` : 'unset')};
    height: ${(props) => (props.height ? `${props.height}` : 'unset')};
    padding: ${(props) =>
        `${props.y ?? 0}px ${props.x ?? 0}px ${props.y ?? 0}px ${props.x ?? 0}px`};
    max-width: ${(props) => props.maxWidth ?? 'unset'};
`;

export const Box = styled.div.withConfig({
    shouldForwardProp: (prop) => {
        return ![
            'alignItems',
            'justifyContent',
            'direction',
            'wrap',
            'gap',
            'flex',
            'br',
            'b',
            'bg',
            'color',
            'width',
            'height',
            'x',
            'y',
            'position',
            'maxWidth',
        ].includes(prop);
    },
})<BoxProps>`
    ${boxStyle}
`;
